/* eslint-disable import/order */
/* eslint-disable prettier/prettier */
import { routes } from "@bvi/admin-panel/api-routes";
import { apiContainer, getItemTags, getListTag, invalidateTags, provideTagsList, TagTypes } from "@bvi/admin-panel/shared/api";
import { getResponseData } from "@bvi/api-interfaces/response";
import {
  IManageBaseListResponse,
  IManageBaseResponse
} from '@bvi/api-interfaces/response/manage-base-data';

interface ICreateJobPositionRequest {
  name: string;
}

export const jobPositionApi = apiContainer.injectEndpoints({
  endpoints: (builder) => ({
    getJobPositionList: builder.query<IManageBaseListResponse, void>({
      query: () => ({
        url: routes.jobPosition.findAll(),
        method: 'GET',
      }),
      providesTags: (result) =>
        result
          ? [
            ...getItemTags(TagTypes.JOB_POSITION, getResponseData(result)),
            getListTag(TagTypes.JOB_POSITION),
          ]
          : [getListTag(TagTypes.JOB_POSITION)],
    }),

    getByIdJobPosition: builder.query<IManageBaseResponse, number>({
      query: (id) => ({
        url: routes.jobPosition.findOne(id),
        method: 'GET',
      }),
      providesTags: provideTagsList(TagTypes.JOB_POSITION)
    }),

    createJobPosition: builder.mutation<
      IManageBaseResponse,
      ICreateJobPositionRequest
    >({
      query: (data) => ({
        url: routes.jobPosition.create(),
        method: 'POST',
        data,
      }),
      invalidatesTags: invalidateTags(getListTag(TagTypes.JOB_POSITION)),
    }),

    updateJobPosition: builder.mutation<
      IManageBaseResponse,
      { id: number; name: string }
    >({
      query: ({ id, name }) => ({
        url: routes.jobPosition.update(id),
        method: 'PATCH',
        data: { name },
      }),
      invalidatesTags: invalidateTags(getListTag(TagTypes.JOB_POSITION)),
    }),

    deleteJobPosition: builder.mutation<void, number>({
      query: (id) => ({
        url: routes.jobPosition.remove(id),
        method: 'DELETE',
      }),
      invalidatesTags: invalidateTags(getListTag(TagTypes.JOB_POSITION)),
    }),
  })
});

export const {
  useGetJobPositionListQuery,
  useLazyGetJobPositionListQuery,
  useGetByIdJobPositionQuery,
  useLazyGetByIdJobPositionQuery,
  useCreateJobPositionMutation,
  useUpdateJobPositionMutation,
  useDeleteJobPositionMutation
} = jobPositionApi;

